import { useContext } from 'react'
import { ClassroomStateContext, ClassroomDispatchContext } from '../contexts'

export const useClassroomState = () => {
  const context = useContext(ClassroomStateContext)
  if (!context) {
    throw new Error(
      'useClassroomState must be used within the ClassroomStateProvider'
    )
  }

  return context
}

export const useClassroomDispatch = () => {
  const context = useContext(ClassroomDispatchContext)
  if (!context) {
    throw new Error(
      'useClassroomDispatch must be used within the ClassroomDispatchProvider'
    )
  }

  return context
}

export const useClassroom = () => {
  return [useClassroomState(), useClassroomDispatch()]
}
